const es = {
  labels: {
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    lastName: "Apellido",
    birthDate: "Fecha de nacimiento",
    timeZone: "Zona Horaria",
    city: "Ciudad",
    position: "Posición (CTO, employee, etc.)",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    biography: "¿Qué quieres que los otros usuarios sepan de ti?",
    motto: "Motto (ex. Memento mori!!)",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    Spotify: "Spotify",
    web: "Página web",
    message: "Escribe aquí tu mensaje",
    messageDisabled: "Podrás escribir en 5 segundos",
    users: "Usuarios",
    user: "Usuario",
    sound: "Sonido",
    mic: "Micrófono",
    speakers: "Salida de audio",
    camera: "Cámara",
    sharing: "Compartiendo",
    spaceName: "Nombre del espacio",
    superSpaceName: "Nombre del campus",
    multiWebinar:
      "Multiwebinar: Conectar los webinar de todos los espacios en uno solo",
    returnToTheCity: "Este campus tiene acceso a la ciudad",
    isPublic: "Este campus es público para todos los usuarios de nubi",
    welcomeText: "Texto de bienvenida",
    scene: "Escena",
    url: "Enlace del video",
    room: "Sala",
    wonderPointUrl: "Url de la web que aparecerá en la descripción",
    videoUrl: "Video anclado a la sala",
    lockVideoUrl: "Mantener el video en la sala",
    roomName: "Nombre de la sala",
    posterName: "Nombre del cartel",
    automaticWonderPoint: "Abrir automaticamente en una pestaña nueva.",
    reason: "Motivo",
    search: "Buscar",
    filters: "Filtrar",
    permissions: "Permisos",
    required: "Requerido",
    optional: "Opcional",
    description: "Descripción",
    comingBack: "Vuelvo el",
    addEmails:
      "Añade correos electrónicos para invitar usuarios, use comas entre correos electrónicos para agregar varios usuarios",
    sentAt: "Enviado a las ",
    invitedBy: "Invitado por",
    sentDate: "Fecha de envio",
    type: "Tipo",
    invitation: "Invitación",
    userInvitationType: "Usuario",
    invitedInvitationType: "Invitado",
    publicInvitationType: "Pública",
    customInvitationType: "Personalizada",
    notFound: "Sin resultados",
    used: "Invitación usada",
    expireDate: "Fecha de expiración",
    yes: "Usada",
    no: "Sin usar",
    publicUrl: "Url pública",
    maxCharacters: " (Caracteres maximos: {number})",
    withSound: "Con sonido en salas",
    withoutSound: "Sin sonido",
    hasSent: "ha enviado",
    spaceType: "Tipo de espacio",
    creatorEmail: "Correo del creador",
    speedNetworkingDuration:
      "Duración de las llamadas de Speed Networking (minutos)",
    generalChatEnable: "Habilitar chat general en el espacio",
    webinarChatEnable: "Habilitar chat en los webinar del espacio",
    chatNameDefault: "Chat de la sala",
    selectPlace: "Dónde quieres ir hoy",
    addFavourite: "Añadir a favoritos",
    removeFavourite: "Quitar de favoritos",
    free: "Libre",
    almostFull: "Casi lleno",
    full: "Lleno",
    itemsPerPage: "Elementos por página",
    language: "Idiomas con los que me siento cómodo/a",
    titleProfileObboarding:
      "Cumplimenta aquello que quieras que OTROS AVATARES sepan de ti.",
    profileObboarding:
      "Tú podrás copiar sus datos y ellos los tuyos. Deja que sepan cómo contactarte tras conocerte.",
    permanentlyBlock: "Bloquear CLAVE permanentemente",
    date: "Fecha",
    status: "Estado",
    showLogsOf: "Mostrar los registro del:",
    downloadCsv: "Descargar CSV",
    from: "Desde",
    to: "Hasta",
    spaces: "Espacios",
    favoriteCampus: "Favoritos",
    publicCampus: "Públicos",
    otherCampus: "Campus a los que has sido invitado",
    disabledPassword:
      "La contraseña está deshabilitada porque el multiwebinar está activo",
    showText: "Escribe el texto que se mostrará (opcional)",
    poster: "Cartel",
    externalDashboardUrl: "Url externa para el dashboard",
    pin: "Pin",
    lowBandWidth: "Ancho de banda bajo",
    experienceTag: "¿En qué tienes más experiencia?",
    learningTag: "¿Qué te gustaría aprender/conocer?",
    projectParticipationTag: "¿Proyectos/Tipo de proyectos en los qué ha participado?",
    addTag: "Añadir tag",
    showExperienceTag: "Mi experiencia",
    showLearningTag: "Me gustaría aprender/conocer",
    showProjectParticipationTag: "Tipos de proyectos en los que he participado",
    activateNotepad: "Activar bloc de notas",
    notepadText: "Texto bloc de notas",
    notepadRoom: "Bloc de notas de la sala",
    tags: "Tags",
    projects: "Proyectos",
    knowledge: "Conocimientos",
    experts: "Expertos",
    contactAddress: "Dirección de contacto",
    phone: "Número de teléfono",
    link: "Enlace de interés",
    nationality: "Nacionalidad",
    personalInformation: "Información Personal",
    gender: "Género",
    title: "Título",
    groupMembers: "Miembros del grupo",
    moreInformation: "Más información",
    spaceDefault: "Espacio por defecto",
    reservePhysicalRoom: {
      imagen: "Imagen",
      physicalRooms: "Salas físicas",
      titlePlant: "Nombre de la planta",
      floorPlanImage: "Imagen de la planta",
      rooms: "Habitaciónes"
    },
    workExperiences: {
      title: "Experiencia laboral",
      position: "Posición",
      startAt: "Fecha de inicio",
      endAtAt: "Fecha de finalización",
      company: "Compañía",
      companyType: "Tipo de compañia",
      description: "Descripción",
    },
    educations: {
      title: "Educación/Formación",
      educationalDegree: "Título educativo",
      startAt: "Fecha de inicio",
      finishAt: "Fecha de finalización",
      place: "Lugar",
      description: "Descripción",
    },
    languageSkills: {
      title: 'Idiomas',
      language: "Idioma",
      listeningSkill: "Habilidad de escucha",
      speakingSkill: "Habilidad para hablar",
      readingSkill: "Hbilidad de lectura",
      writingSkill: "Habilidad para la escritura",
    },
    digitalSkill: {
      title: 'Habilidades digitales',
      informationProcessing: "Procesamiento de información",
      communication: "Comunicación",
      contentCreation: "Creación de contenido",
      safety: "Seguridad",
      problemSolving: "Resolución de problemas"
    },
    otherSkill: {
      title: "Otras habilidades",
      communication: "Comunicación",
      organizationalOrManagement: "Organización o Gestión",
      teamWork: "Trabajo en equipo",
      drivingLicense: "Licencia de conducir",
    },
    aboutYou: {
      title: "¿En qué te consideras bueno profesionalmente?",
      aboutYou: "Lo que pretendemos es que cuando un compañero necesite resolver algún problema, pueda contar contigo. Describe todo aquello en lo que tú creas que pueden consultarte en caso de ayuda.",
      message: "Escribe aquí",
    },
  },
  sidebar: {
    nubiiSpace: "nubi espacio",
    usersInSpace: "Usuarios en el espacio",
    usersOnline: "Usuarios activos",
    noMatches: "No hay coincidencias",
    messages: "Mensajes",
    footer: {
      help: "Ayuda y Soporte",
      legalTerms: "Términos legales",
      suggestions: "¿Ideas?",
      defaultSpot: "Lugar por defecto",
    },
  },
  buttons: {
    logIn: "Entrar",
    send: "Enviar",
    save: "Guardar",
    changeEmail: "Modificar Correo",
    yes: "Si",
    no: "No",
    delete: "Eliminar",
    edit: "Editar",
    changeScene: "Cambiar escenario",
    changeSpace: "Cambiar espacio",
    removeImagen: "Quitar imagen del logo",
    removeImagenPoster: "Quitar imagen del cartel",
    removeImageRoom: "Quitar imagen de la sala",
    removeImagenScreenRoom: "Quitar imágenes de las pantallas de las salas",
    goToSpace: "Ir a este espacio",
    cancel: "Cancelar",
    accept: "Aceptar",
    copy: "Copiar",
    copyUserInfo: "Copiar información del usuario",
    next: "Siguiente",
    saveAndNext: "Guardar y continuar",
    exitToCity: "Salir a la ciudad",
    exitLeave: "Salir de nubi",
    start: "Iniciar",
    backToNubii: "Volver a nubi",
    imReady: "Estoy listo!",
    skip: "Saltar este paso",
    letsGo: "Vamos allá",
    openUrl: "Abrir web",
    goTo: "Ir a la sala",
    openInTab: "Abrir en pestaña",
    iKnow: "De acuerdo, continuar",
    sendInfoUserEmail: "Enviar información a mi correo",
    createSpace: "Crear espacio",
    showProfile: "Ver perfil",
    enter: "Entrar",
    inviteMoreUsers: "Invitar mas usuarios",
    sendNewMessage: "Enviar nuevo mensaje",
    newMessage: "Nuevos mensajes",
    backGame: "Volver al juego",
    addSpace: "Añadir espacio",
    inviteFriend: "Invitar a un amigo",
    showRooms: "Ver salas",
    enterInSpace: "Entrar al espacio",
    showAll: "Ver todos",
    iNeedHelp: "Necesito ayuda...",
    deleteVideo: "Quitar vídeo",
    reload: "Actualizar espacios",
    unsubscribe: "Eliminar mi cuenta",
    addUrl: "Añadir enlace de invitación",
    addVisitSpace: "Agregar visita a un espacio",
    clearChat: "Vaciar chat",
    programNotification: "Anuncios programados",
    usersGroup: "Grupo de usuarios",
    openDashboardUrl: "Ver dashboard de actividad",
    gotoCity: "Ir a la ciudad",
    retryPin: "Reenviar email con el número PIN",
    reloadNubi: "Recargar",
    cleanAndStart: "Limpiar y empezar",
    sendReport: "Enviar reporte",
    congratulate: "Felicitar",
    notepad: "Bloc de notas",
    createSpaceOrHelp1: "Pulsa",
    createSpaceOrHelp2: "si quieres crear tu propio espacio nubi. O contacta con nosotros ",
    createSpaceOrHelp3: "para ayudarte a entender cómo lo usan nuestros clientes.",
    here: "aquí",
    activate: "Activar",
    disable: "Desactivar",
    add: "Añadir",
    sendCurriculum: "Enviar currículum",
    updateCurriculum: "Actualizar currículum",
    deleteCurriculum: "Borrar currículum",
    hide: "Ocultar",
    close: "Cerrar",
  },
  tooltips: {
    exit: "Salir",
    spaceLabels: "Etiquetas",
    noWall: "Ocultar paredes",
    rotate: "Girar la cámara para actualizar",
    disableNoWall: "En este espacio no es posible usar esta funcionalidad",
    mode3D: "Modo 3D",
    mode2D: "Modo 2D",
    activateCamera: "Activar cámara",
    deactivateCamera: "Desactivar cámara",
    activateMic: "Activar micrófono",
    deactivateMic: "Desactivar micrófono",
    shareScreen: "Compartir pantalla",
    unShareScreen: "Dejar de compartir",
    noWorkingTeams1: "MS Teams no permite compartir pantalla a aplicaciones externas como nubi. Para usarla has de ",
    noWorkingTeams2: "abrir nubi en una pestaña separada",
    openChat: "Abrir chat",
    config: "Opciones",
    expand: "Expandir",
    contract: "Contraer",
    endCall: "Colgar llamada",
    enterCall: "Coger llamada",
    editProfile: "Editar perfil",
    changeEmoji: "Reaccionar",
    busy: "Ocupado",
    call: "Disponible",
    cameraOptions: "Navegación",
    angles: "Ángulos",
    moveSpace: "Mover espacio",
    zoom: "Zoom",
    centerMyAvatar: "Centra mi avatar",
    deleteInvitation: "Eliminar invitación",
    increaseInvitation: "Incrementar expiración",
    question: "Pregunta",
    sendQuestion: "Enviar este mensaje como una pregunta",
    send: "Enviar",
    paperPlane: "Avión de papel",
    global: "Anuncio",
    pinnedBy: "Anclado por",
    deletePinned: "Eliminar mensaje anclado",
    hide: "Esconder",
    callBack: "Volver a la llamada",
    changePin: "Cambiar Clave",
    textChangePin:
      "Esta sala está permanentemente bloqueada desde el administrador del espacio",
    handUp: "Levantar la mano",
    disableSpace: "El espacio está deshabilitado",
    deleteUser:
      "Tu usuario ha sido eliminado de este espacio. Solo puedes volver a acceder si te envían una invitación.",
    disableUser:
      "Estás baneado de este espacio. Ponte en contacto con el administrador.",
    activeInSuperSpace: "Este permiso está activo en el campus",
    imHome: "Estoy en casa",
    imOffice: "Estoy en la oficina",
    shareVideo: "Compatir vídeo",
    diary: "Agenda",
    buzz: "Zumbar",
    mute: "Silenciar",
    noShowCam: "Apagar cámara",
    changeLayout: "Cambiar diseño de cámaras",
    focusModeOn: "Activar modo concentración",
    focusModeOff: "Desactivar modo concentración",
    disableSpaceNubi: "El espacio ha sido deshabilitado por nubi",
    noSend: "Máximo de caracteres superado",
    searchFilters: "Filtros de búsqueda",
    filtersKnowledge: "Al marcar esta opción se mostrarán los usuarios con esta experiencia o que la quieran aprender",
    filtersProjects: "Al marcar esta opción se mostrarán los usuarios que participan en el proyecto",
    filtersExperts: "Al marcar esta opción se mostrarán los usuarios que sean expertos",
    deleteImage: "Quitar imagen",
    addImage: "Añadir imagen",
    changeImage: "Cambiar imagen",
    imageNotSaved: "Imagen no guardada",
    notCompatibleSafari: "Actualmente no se puede compartir pantalla con Safari",
    delete: "Borrar",
    edit: "Editar",
    addUserAndDelete: "(Añadir / Eliminar) usuarios",
    dragUsers: "Puedes trasladar a los usuarios de un campo a otro arrastrándolos",
    disableGame: "Para activar el juego, se necesitan 3 jugadores en línea",
    activeGame: "Al darle a activar, se inicializará el juego",
    info: "Información",
    save: "Guardar",
  },
  validatorError: {
    required: "El campo es requerido",
    email: "Debes introducir un email valido",
    minLength:
      "La contraseña debe tener como minimo {count} caracteres de longitud",
    sameAs: "Las contraseñas no coinciden",
    invalidUrl: "Url inválida, deberia ser https://www.example.com",
  },
  notifications: {
    titles: {
      error: "ups!",
      success: "Fantástico!",
      information: "Información",
      requestPassword: "Solicitud de cambio de contraseña",
    },
    descriptions: {
      userBan: "Usuario baneado exitosamente",
      userUpdate: "Perfil actualizado exitosamente",
      spaceUpdate: "Espacio actualizado exitosamente",
      emojiUpdate: "Emoji modificado exitosamente",
      avatarUpdate: "Avatar modificado exitosamente",
      petUpdate: "Mascota modificado exitosamente",
      roomUpdate: "Sala modificada exitosamente",
      posterUpdate: "Cartel modificado exitosamente",
      urlUpdate: "Enlace modificado exitosamente",
      reasonUpdate: "Motivo actualizado correctamente",
      requestPassword:
        "Se ha enviado a {email} un correo para realizar el cambio de contraseña",
      resetPassword: "Contraseña modificada ",
      deleteSpaceUser: "Usuario eliminado del espacio",
      activeSpace: "El espacio se ha activado satisfactoriamente",
      activeSpace2:
        "Revisa tu correo electrónico por última vez para iniciar sesión en su nuevo espacio nubi",
      copyUrl: "Url copiada en el portapapeles",
      copyInfo: "Información copiada en el portapapeles",
      confirmEmail: "Correo de confirmación enviado satisfactoriamente",
      skip: "Ya eres un experto usando nubi? si quieres puedes saltarte este paso.",
      successActivateUser:
        "Usuario activado satisfactoriamente, si eres usuario nuevo revisa tu bandeja de correo, hemos enviado tus credenciales para acceder a nubi, si no, puedes ingresar directamente desde el login",
      sendInvitations: "Invitaciones enviadas satifastoriamente",
      vacationOn: "Vacaciones actualizadas exitosamente",
      deleteInvitation: "Invitación eliminada satisfactoriamente",
      increaseInvitation: "Tiempo de expiración aumentado satisfactoriamente.",
      recoveringPassword:
        "Hemos enviado un correo electrónico para recuperar la contraseña.",
      emailNotRegistered: "Este correo electrónico no está registrado en nubi.",
      waitSendRecoveryPassword:
        "Debes esperar 5 minutos para volver a solicitar la contraseña.",
      muteExternalMic: "ha silenciado tu micrófono",
      stopExternalCam: "ha apagado tu cámara",
      buzzed: "te esta zumbando",
      recommendTurningOff:
        "Parece que tienes un ancho de banda muy bajo, te recomendamos apagar tu camara",
      sendInfoEmail:
        "Información del usuario enviada a tu correo satisfactoriamente.",
      deleteSpace: "Espacio eliminado satisfactoriamente",
      createSpace: "Espacio creado satisfactoriamente",
      chatCopied: "Chat copiado al portapapeles",
      pinnedMessage: "Mensaje anclado satisfactoriamente",
      deletePinnedMessage: "Mensaje anclado eliminado satisfactoriamente",
      disableUser: "Usuario deshabilitado satisfactoriamente",
      spaceFull: "El espacio está lleno, selecciona otro.",
      assignedMyPlaceDefault:
        "Asignado tu lugar por defecto. En adelante, cuando entres a nubi o pierdas momentáneamente la conexión, irás directamente a ese sitio.",
      calendarUpdate: "Calendario actualizado satisfactoriamente",
      videoAudio: "Video y Audio actualizado correctamente",
      pinRequest:
        "¡Ya!, perfecto. te hemos enviado un email con tu número PIN de acceso de UN SOLO USO. Si no lo ves en unos segundos, revisa tu carpeta de SPAM.",
      pinErrorUserNotExist:
        "No tenemos ese correo electrónico como usuario de nubi.",
      pinInvalidCredentials: "Correo electrónico o pin incorrecto.",
      pinRequestApin: "Solicita un pin.",
      pinExceeded:
        "Ha superado los intentos de inicio de sesión con este pin. Solicita uno nuevo.",
      pinExpired: "El PIN ha caducado. Solicita uno nuevo.",
      sendReport: "Reporte enviado satifastoriamente",
      autoplayCheckT: "Se ha detectado que el vídeo está configurado para empezar a reproducirse a partir de un segundo concreto. El autoplay solo funciona cuando el vídeo comienza desde el principio.",
      permissionError: "No se puede acceder a los permisos",
      sendReportOk: "El informe ha sido enviado",
      sendVoteOk: "El voto ha sido enviado",
      createGroup: "Grupo creado",
      editGroup: "Grupo editado",
      removeGroup: "Grupo borrado",
      createCurriculum: "Currículum creado exitosamente",
      updateCurriculum: "Currículum actualizado exitosamente",
      deleteCurriculum: "Currículum eliminado exitosamente",
      createReserve: "Reserva creada con éxito",
      updateReserve: "Reserva actualizada con exito",
      removeReserve: "Reserva actualizada con éxito",
      reserveRoomStart: "La sala está reservada",
      reserveRoomFinish: "La reserva ha finalizado",
      saveAutoVideo: "Grabación guardada correctamente",
      createPhysicalPlantAndRoom: "Guardada correctamente",
    },
    newMessage: {
      title: "nubi mensaje recibido",
      titleRoom: "nubi mensaje recibido en la sala",
      body: "{name} te ha enviado un mensaje",
      bodyRoomGeneral: "{name} ha enviado un mensaje al chat general",
      bodyRoomRoom: "{name} ha enviado un mensaje al chat de la sala",
      bodyRoom: "{name} te ha enviado un mensaje",
      sendNewMessage: "Mensaje enviado satifastoriamente",
    },
    newConsoleMessage: "{name} ha enviado un anuncio",
    openWebinar: "{name} {lastname} ha iniciado el webinar",
    closeWebinar: "{name} {lastname} ha finalizado el webinar",
    newPaperPlane: "{name} {lastName} te ha enviado un avión de papel",
    newPaperPlaneApp:
      "{name} {lastName} está conectado desde la app de nubi, te ha enviado un avión de papel desde {room}.",
    sendNewPaperPlane: "Has enviado un avión de papel",
    sendBirthdayCake: "{name} {lastName} te ha enviado un tarta de cumpleaños",
    permissionsOk: {
      title: "Notificaciones encendidas",
      body: "Las notificaciones se activaron con éxito",
    },
    announcement: "Anuncio",
    warningMessages: {
      youAreOnCall: "Ya estás en una llamada.",
      isBusy: "{name} está ocupado.",
      triedCallYou: "{name} intentó llamarte",
      emojiIsNotChangedOnCall:
        "No se puede cambiar el emoji si estás en una llamada.",
      stateIsNotChangedOnCall:
        "No se puede cambiar el estado si estás en una llamada.",
      connectionIsLow:
        "Hemos detectado que la conexión es demasiado lenta, por favor espera.",
      emailInSpace: "Ya existe dentro del espacio",
      emailErrorGuest:
        "Los usuarios invitados no pueden utilizar la invitación de usuario",
      nextMaintenance:
        "Hola, En nubi estamos de reformas.<br><b>A las {date}</b><br>tenemos que cerrar nuestras instalaciones durante unos minutos para terminar de pintar, colgar algún cuadro y... hacer de nubi la mejor herramienta para gente remota.",
    },
    errorMessages: {
      connectionIsLowRefresh:
        "No Hemos podido cargar los archivos necesarios para que nubi funcione, puede que tu computador o tu conexión tengan problemas. Haz",
      connectionIsLowRefreshClick: "click aquí",
      connectionIsLowRefresh2: "para reintentar.",
      reasonUpdate: "No se ha podido actualizar el motivo correctamente",
      updatePerfil:
        "No se ha podido actualizar el perfil, Por favor, inténtalo más tarde",
      invalidCredentials: "Correo electrónico o contraseña incorrecta",
      invalidPassword: "Contraseña incorrecta",
      resetPassword:
        "No se ha podido modificar tu contraseña, por favor vuelve a intentarlo o ponte en contacto con soporte",
      pusherError:
        "Los canales no son compatibles con el navegador, por favor ponte en contacto con soporte.",
      spaceDisabled:
        "El espacio está deshabilitado, selecciona otro o ponte en contacto con el soporte.",
      spaceUserDisabled:
        "Tu usuario ha sido deshabilitado por el administrador de este espacio.",
      userBanned:
        "El usuario está deshabilitado. Por favor, ponte en contacto con el soporte.",
      userDelete:
        "El usuario ha sido borrado. Por favor, ponte en contacto con el soporte.",
      userSpaceBanned:
        "El usuario está deshabilitado del espacio, selecciona otro o ponte en contacto con el soporte.",
      spaceDelete:
        "El espacio ha sido borrado, Por favor, ponte en contacto con el soporte.",
      spaceUserDelete:
        "El usuario ha sido borrado del espacio, Por favor, ponte en contacto con el soporte.",
      invitationExpired: "La invitación es inválida o ya ha caducado.",
      generateToken:
        "No pudimos generar la invitación, vuelve a intentarlo o ponte en contacto con el soporte.",
      activateUser:
        "No pudimos activar tu cuenta, vuelve a intentarlo o ponte en contacto con el soporte.",
      connectRoom:
        "No se ha podido conectar a la llamada, sal de la sala y vuelve a intentarlo",
      connectRoomError:
        "No se ha podido conectar a la llamada",
      connectOneToOneError:
        "El otro usuario no está en la llamada",
      maxFileSize:
        "El tamaño de la imagen no es permitido, debe ser menor a 2mb",
      fileType: "Solo se permiten archivos png, jpg y jpeg",
      linkCannotBeUsed: "El enlace no se puede usar con dicho usuario",
    },
    noInternetConnection:
      "Estás sin conexión, es posible que algunas funciones no estén disponible",
    noChrome:
      "nubi está optimizado para el navegador Google Chrome. Puedes descargarlo gratis desde ESTE ENLACE",
    noWebGl2:
      "nubi necesita que tengas habilitado WebGl2 en tu explorador. Realiza ESTE TEST para comprobar que esté habilitado",
    noMobile:
      "Por ahora nubi sólo funciona en Google Chrome para escritorio. Estamos trabajando para que puedas acceder desde más plataformas.",
    downloadHere: "Descarga chrome aquí",
    testHere: "Ingresa a el test aquí",
    iploneMobile: "Puedes descargar la app para iPhone ",
    androidMobile: "Puedes descargar la app para Android ",
    here: "aquí",
    devices: {
      title: "Dispositivos no configurados",
      permissions:
        "Para que otros usuarios puedan verte y oirte debes dar permisos de acceso a tu cámara y micrófono en tu navegador. Pulsa en el icono en forma de candado en la barra de direcciones, permite el acceso a audio y cámara. Tras eso, debes recargar la página pulsando F5 en Windows o CMD+R en Mac",
      withoutDevices:
        "Tu navegador le dice a nubi que no ha encontrado {devices}. Sal de la sala y ve a la configuración en el menú superior derecho de nubi para seleccionar alguno de la lista. Si no ves ninguno instalado, es que tu navegador no lo detecta. Intenta verificar los permisos pulsando en el icono en forma de candado en la barra de direcciones, permite el acceso a micrófono y cámara. Tras eso, debes recargar la página pulsando F5 en Windows o CMD+R en Mac. Si nada de esto funciona, prueba a reiniciar todo de cero.",
      devices1: "ninguna camara activa",
      devices2: "ningún micrófono activo",
      devices3: "ninguna cámara ni micrófono activo",
      noPermissions:
        "Tu sistema operativo o tu explorador no tienen permisos de usar {devices}, revisa la configuración de tu sistema o explorador y vuelve a recargar nubi pulsando F5 en Windows o CMD+R en Mac.",
      cam: "la camara",
      mic: "el micrófono",
      record: "grabación de pantalla",
      permissionDenied: "Permisos denegados",
    },
    genericError: {
      genericError:
        "Ha ocurrido un error {code}, por favor ponte en contacto con soporte.",
      genericErrorRetry: "Ha ocurrido un error, por favor vuelve a intentarlo.",
      genericErrorClientGraphic:
        'Ha ocurrido un error inesperado. Al pulsar "Recargar" reiniciamos nubi. Si el error persiste, pulsa en "Limpiar y empezar", que es más radical y deberás volver a identificarte o pulsar en el enlace de invitación.',
      genericErrorTeams:
        'Ha ocurrido un error inesperado. Al pulsar "Recargar" reiniciamos nubi. Si el error persiste, por favor ponte en contacto con soporte.',
      updateRoom:
        "Ha ocurrido un error al actualizar la sala, por favor ponte en contacto con soporte.",
      updateImage:
        "Ha habido un error en la subida. Por favor, inténtalo mas tarde",
      activeSpace:
        "Ha ocurrido un error al activar el espacio, por favor ponte en contacto con soporte.",
    },
    errorCode: {
      "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f":
        "El correo electrónico ya está en uso.",
      "bd79c0ab-ddba-46cc-a703-a7a4b08de310":
        "No es una dirección de correo electrónico válida.",
    },
    apiMessage: {
      EMAIL_FOR_ACTIVATION_SENT:
        "Hemos enviado un correo electrónico para completar la activación.",
      ERROR_TOKEN_NOT_FOUND:
        "El sistema no encuentra la invitación para activar",
      ERROR_USER_INVITATION_ACTIVATED_ALREADY:
        "Esta invitación ya ha sido activada",
      ERROR_USER_INVITATION_IS_DELETED: "Esta invitación ha sido eliminada",
      ERROR_USER_BELONG_SPACE_ALREADY:
        "¡Bienvenido de nuevo! Redireccionándote a tu espacio...",
      ERROR_GUEST_USER_ARE_NOT_ALLOWED_TO_USE_USER_INVITATION:
        "Los usuarios invitados no pueden utilizar la invitación de usuario",
      ERROR_YOUR_USER_IS_BEING_CREATED_TRY_AGAIN:
        "Su usuario se está creando. Vuelva a pulsar el enlace del correo electrónico en unos segundos",
      ERROR_INVITATION_HAS_EXPIRED: "Esta invitación ha expirado",
      ERROR_SPACE_IS_DELETED: "El espacio ha sido borado",
      "name is required": "Se requiere el nombre",
      ERROR_SPACE_ACTIVATED_ALREADY: "Este espacio ya ha sido activado.",
      ERROR_SPACE_IS_BEING_CREATED_TRY_AGAIN:
        "El espacio se está creando. Haz clic en el enlace de activación en unos segundos",
      ERROR_SUPER_ADMIN_CANNOT_BE_INVITED: "Superadmin no puede ser invitado",
      SUPER_SPACE_NAME_EXISTS: "Ya existe un Multi Espacio con este nombre",
      ERROR_USER_BELONG_SPACE_ALREADY_NO_TOKEN:
        "Tu usuario ya pertenece a este espacio, identifícate para acceder a él",
    },
  },
  status: {
    available: "Disponible",
    availableMessage: "¡Cuidado! Podrán llamarte sin avisar",
    busy: "Ocupado",
    call: "Sonar al llamar",
    callMessage:
      "Tu cámara y audio estarán apagados cuando recibas una llamada",
    noStatus: "Sin estado",
    offline: "Desconectado",
    vacation: "De vacaciones",
    reasons: {
      reason: "Motivo",
      eating: "Comiendo",
      resting: "Descansando",
      focused: "Concentrado",
      call: "En una llamada",
      vacation: "De vacaciones",
      anotherReason: "Otro motivo",
    },
  },
  actions: {
    avatar: "Avatar",
    pet: "Mascota",
    chat: "nubi chat",
    exit: "Salir",
    logout: "Cerrar sesión",
    workInOffice: "Estoy en la oficina",
    manageSpaces: "Gestionar espacio",
    manageCampus: "Gestionar campus",
    profile: "Mi perfil",
    sendConsoleMessage: "Enviar anuncio general",
    videoCallSettings: "Ajustes de videollamada",
    support: "Soporte / Ayuda",
    multiplayerToolKit: "Power-ups",
    config: "Configuración",
    sendConsoleMessageMultiespacio:
      "Si tienes más de un espacio en este campus, enviarlo a TODOS",
    utilities: "Utilidades",
  },
  auth: {
    welcome: "Bienvenido",
    forgot: "¿Olvidaste tu contraseña?",
    backToLogin: "Volver al login",
    forgotTitle: "Solicitar cambio de contraseña",
    resetTitle: "Ingresa tu nueva contraseña",
    pinlink: "Acceder con un PIN que enviamos a tu email.",
    pinTitle: "Solicitar PIN de acceso.",
    pinLoginTitle: "Acceder con PIN.",
    pintDescription: "Escribe tu correo asociado a la cuenta de nubi.",
    welcomeGicar: "Acceso con credenciales corporativas (Gicar)",
  },
  manageSpaces: {
    sidebar: {
      users: "Usuarios",
      manageUsers: "Usuarios del espacio",
      inviteUsers: "Invitar usuarios",
      pendingUsers: "Usuarios pendientes",
      space: "Espacio",
      customizeSpace: "Personalizar",
      customizeRooms: "Gestionar salas",
      wonderPoints: "WonderPoints",
      campusSpaces: "Espacios del campus",
      spaceSettings: "Configuración",
      multiSpace: "Campus",
      customizeMultiSpace: "Personalizar",
      settingsMultiSpace: "Configuración",
      manageUsersSuperSpace: "Usuarios del campus",
      goToCampus: "Volver al campus",
      announcements: "Anuncios",
      announcementsCampus: "Anuncios en el campus",
      announcementsSpace: "Anuncios en el espacio",
      posters: "Carteles",
    },
    customizeSuperSpace: {
      logoImage: "Logo del campus",
      uploadLogoImage:
        "Esta imagen corresponde al logo que verán los usuarios en la ciudad.",
      changeWebinarType:
        "¿Estás seguro de cambiar el tipo de webinar del espacio?, esto podria afectar al webinar en curso",
    },
    customizeSpace: {
      warningOpenUrl:
        "Advertencia, no todas las urls se pueden abrir dentro de nubi",
      openUrlExternally: "Abrir automaticamente en una pestaña nueva.",
      selectScene: "Selecciona el espacio",
      logoImage: "Logo del espacio",
      uploadLogoImage:
        "Esta imagen corresponde al logo que verán los usuarios en el menu.",
      uploadBackgroundImage:
        "Esta imagen se va a utilizar en la landing que se generará (en un futuro) al crear un espacio",
      boardImage: "Cartel de la entrada",
      uploadBoardImage:
        "Esta imagen es la que se muestra en el cartel que se encuentra en la puerta principal del espacio",
      uploadCommonImage:
        "En el caso de que haya pantallas de salas sin definir, se usará esta imagen para mostrarla por defecto",
      roomImage: "Pantallas de la sala",
      uploadRoomImage:
        "Esta imagen se utilizará por defecto en todas las pantallas que hay en cada sala del espacio.",
      uploadOneRoomImage:
        "Esta imagen se va a utilizar en la pantalla de esta sala.",
      selectRoom: "Selecciona la sala",
      editRoom: "Edita los valores de la sala",
      selectPoster: "Selecciona el cartel",
      editPoster: "Edita los valores del cartel",
      posterImage: "Imagen del cartel",
      uploadPosterImage: "Esta imagen se va a utilizar en el cartel.",
      urlPoster: "Enlace anclado al cartel",
      noPosters: "No hay carteles en este espacio",
    },
    inviteUsers: {
      title: "¡Hola! ¿Qué tipo de usuario deseas agregar?",
      userDescription:
        "Tiene correo electrónico y contraseña.Se requiere registro.Usuario permanente en el espacio",
      guestDescription:
        "No tiene correo electrónico ni contraseña.Solo de visita.Usuario temporal",
      orShareLink: "O comparte este enlace",
      addGuidedVisit: "Añadir visita guiada",
      sendInvitations: "Enviar Invitación",
      newInvitation: "Nueva invitación",
      withOnboarding: "Se mostrará el onboarding al entrar al espacio",
      alwaysGoToRoom: "Ir siempre automáticamente a la sala.",
      generateNewUrl: "Generar nuevo enlace",
      confirmGenerate:
        "¿Estás seguro de volver a generar un nuevo enlace?, los usuarios no podrán acceder desde el enlace anterior.",
      pendingInvitations: "Invitaciones pendientes",
      grazingDescription:
        "Elige a qué sala quieres que el usuario vaya automáticamente (la primera vez que inicie sesión)",
      noGrazing: "Sin visita guiada",
      guestInvitation: "Solo como invitado",
      userInvitation: "nubi Usuario",
      selectLanguage: "Selecciona el idioma en el que se manda la invitación",
      dateExpiration: "La invitación caduca el",
    },
  },
  manageUsers: {
    group: {
      groups: "Grupos",
      createGroup: "Crear grupo",
      editGroup: "Editar grupo",
      editUsers: "Editar usuarios"
    },
    table: {
      user: "Usuario",
      email: "Correo",
      enabled: "Habilitado",
      disabled: "Deshabilitado",
      lastConnection: "Última conexión",
      noLastConnection: "Sin última conexión",
      name: "Nombre",
      space: "Espacio",
      spaceType: "Tipo de espacio",
    },
    permissions: {
      button: "Aplicar a {users} usuarios",
      title: "Permisos",
      canInvite: "Puede invitar más usuarios",
      isAdmin: "Puede administrar el espacio",
      isCampusAdmin: "Puede administrar el campus",
      isWebinarHost: "Es ponente de webinar ",
      isMultiWebinarHost: "Es ponente de webinar en el campus",
      onlyInMultiWebinar: "Solo cuando el multi webinar esta activo",
      globalMessage: "Puede enviar avisos",
      isTrial: "Prácticas",
      isEmployed: "Usuario",
      canPinChatMessage: "Puede anclar mensajes",
      canBan: "Puede banear a otros usuarios",
      canChangeRoomPin: "Puede cambiar la clave de acceso de una sala",
      disableIsAdmin:
        "Los administradores del campus o espacio no pueden ser deshabilitados",
      disableIsCampusAdmin:
        "Los administradores del campus no pueden ser deshabilitados",
      canUploadPhoto: "Puede subir fotos en PowerUps",
      canMuteAndCamera: "Puede silenciar y apagar cámaras en las salas de reuniones",
      canMuteAndCameraInstructions: "Para que este permiso surta efecto tiene que salir y entrar de la sala",
      gobalPermission: "Permisos globales del campus",
      spacePermission: "Permisos específicos del espacio",
      noGlobalPermission: "No hay permisos globales",
      canManageMeetingControl: "Puede silenciar micrófono y apagar cámaras en las llamadas",
      canManageWebinar: "Puede activar y desactivar ponentes en el webinar",
      rol: "Rol de usuario",
      showSpotify: "Habilitar Spotify",
    },
    tooltip: {
      webinar: "Tiene permisos de webinar",
      admin: "Es administrador",
      canInvite: "Puede invitar usuarios",
      globalMessage: "Puede enviar avisos",
      canPinChatMessage: "Puede anclar mensajes",
      canBan: "Puede banear a otros usuarios",
      canChangeRoomPin: "puede cambiar el clave de una sala",
      canUploadPhoto: "Puede subir fotos en PowerUps",
    },
    filter: {
      none: "No tiene ningún rol especial",
      all: "Todos los usuarios",
      webinar: "Es un ponente en los webinars",
      admin: "Puede administrar el espacio",
      canInvite: "Puede invitar usuarios",
      globalMessage: "Puede mandar avisos",
      isTrial: "Está en prácticas/beca",
      disabled: "Usuarios deshabilitados",
      userOnline: "Usuarios conectados",
      canPinChatMessage: "Puede anclar mensajes",
      canBan: "Puede banear a otros usuarios",
      canChangeRoomPin: "Puede cambiar CLAVE de una sala",
    },
    confirmDelete: {
      title: "Eliminar usuario del espacio",
      description:
        "¿Estás seguro de eliminar este usuario?, no podrá volver a ingresar a este espacio",
    },
  },
  announcements: {
    addNew: "Crear nuevo anuncio",
    title: "Título del anuncio",
    frequency: "Repetir anuncio",
    justOne: "Solo una vez",
    everyHalfHour: "Cada media hora",
    everyHour: "Cada hora",
    time: "Enviar a las",
    text: "Texto del anuncio",
    timeToSend: "Fecha de envio",
    confirmDelete: {
      title: "Eliminar anuncio",
      description: "¿Estás seguro de eliminar este anuncio?",
    },
    successDelete: "Anuncio eliminado satisfactoriamente",
    successCreate: "Anuncio create satisfactoriamente",
    chexboxText: "Repetir este anuncio todos los {day}",
    text1: "Del campus",
    text2: "Del espacio",
    repeat: "Se repite",
    every: "Cada {day}",
    no: "No",
  },
  profile: {
    sidebar: {
      general: "General",
      security: "Seguridad",
      social: "Social",
      logs: "Registro de eventos",
      videoAudio: "Configurar dispositivos",
      knowledge: "Conocimientos",
      curriculum: "Currículum",
    },
    security: {
      veryWeakPassword: "Contraseña muy débil",
      weakPassword: "Contraseña débil",
      securePassword: "Contraseña segura",
      strongPassword: "Contraseña muy segura",
      differentPassword: "La contraseña no coincide",
    },
    confirmUnsubscribe: {
      title: "Eliminar mi cuenta de nubi",
      checkBoxText: "Eliminar cuenta",
      description:
        "¿Realmente quieres eliminar tu cuenta de nubi?, no podras tener acceso con este usuario",
    },
  },
  consoleMessage: {
    title: "Nuevo anuncio",
    all: "Todos",
    noSound: "Sin sonido",
    dingDong: "Ding Dong Ding",
  },
  newMessage: {
    title: "Nuevo mensaje directo",
  },
  paperPlane: {
    title: "Nuevo avión de papel",
  },
  configDevices: {
    videoConference: "nubi tiene funciones de videoconferencia...",
    chooseDevices: "¿Puedes verte?",
    noPermissions: "Sin acceso a micrófono y cámara",
    popupPermissions: "Debes darnos permisos para usar tu cámara y micrófono",
    allowPermissionsText:
      "Permitir que Google Chrome acceda a mi cámara y micrófono",
    allowPermissions: "Permitir acceso",
    skip: "Omitir esta parte",
    skipModal: "¿Estás seguro? La cámara y micrófono no funcionarán en nubi.",
    clickAllow: 'Haz clic en "Permitir" en la ventana emergente del navegador',
    havingIssues: "¿Tienes problemas?",
    browsersStuck:
      "Los navegadores a veces fallan al capturar la cámara. Para arreglar esto",
    refreshPage:
      "Intenta actualizar la página. Hemos modificado la configuración de la cámara para que sea más probable que funcione.",
    checkPermissions:
      "Revisa los permisos de cámara y micrófono en tu explorador",
    help: "Si eso no funciona",
    contactUs: "contáctanos",
  },
  webinarUrlModal: {
    title: "Compartir video en el webinar",
    activeWebinar: "Iniciar Webinar",
    description:
      "Puedes incluir un enlace de youtube para que este se reproduzca en el webinar o dejar el campo vacío si no necesitas ningún vídeo",
    cancelWebinar:
      "¿Estás realmente seguro de cerrar el webinar? todas las personas que estén dentro, serán desconectadas de inmediato",
  },
  meetingUrlModal: {
    title: "Compartir vídeo",
    description:
      "Puedes incluir un enlace de youtube para que este se reproduzca",
    autoplay: "Reproducción automática",
  },
  otherReasonModal: {
    title: "Indica otro motivo por el cual estás ocupado",
  },
  changeSpaceModal: {
    description:
      "Estos son los espacios que tienes disponibles y que puedes visitar. Para ir a otro espacio haz clic sobre el que desees en la lista y seras redirigido automáticamente. ",
    active: "Estás aquí",
  },
  confirmBanModal: {
    text: "Al expulsarlo, el usuario quedará además deshabilitado hasta que lo cambies en el menú de usuarios.",
    buttonConfirm: "Confirmar",
    buttonCancel: "Cancelar",
  },
  vacationModal: {
    title: "¿Cuándo vuelves de vacaciones?",
    label: "Deja saber a tus compañeros la fecha en que vuelves a nubi.",
    error: "Selecciona la fecha de tu vuelta de vacaciones",
  },
  callErrorModal: {
    title: "Información",
    text: "Dado que llevas un buen rato con la cámara encendida sin interactuar con otro avatar, por privacidad nubi te ha sacado de la sala. Vuelve a entrar si deseas continuar.",
    callReset: "Reconectar a la llamada",
  },
  check: {
    checkEmail: "El correo electrónico no es válido",
  },
  changeAvatar: {
    title: "Seleciona tu avatar",
  },
  changePet: {
    title: "Seleciona tu mascota",
  },
  onBoarding: {
    welcome: {
      welcome: "Bienvenido a",
      welcomeDescription:
        "¡Este es tu espacio en la nubi! Conecta con tus compañeros y sentíos juntos, sin importar dónde estéis. ¿Estás listo?",
      welcomeDescriptionLine2: "¿Estás listo? ¡Esperamos que lo disfrutes!",
    },
    suggestions: {
      noShow: "No volver a mostar",
      one: "Para desplazarte por nubi, haz doble click sobre el lugar al que quieres ir.",
      two: "Puedes acercar o alejar la pantalla para ver todo el espacio de nubi sin mover tu avatar de su sitio.",
      three:
        "Hay ciertas salas de reunión en nubi en las que al entrar, tu cámara y tu micrófono se activarán automáticamente.",
      four: "Chatea con otros avatares a través de mensajes directos, llamadas privadas 1:1 o en el chat de sala.",
      five: "Si te invitan a dos o más espacios de nubi, aquí puedes elegir qué espacio quieres visitar y viajar de uno a otro fácilmente.",
      six: "Si haces click sobre un usuario podrás interactuar con él y enviarle aviones de papel con mensajes para captar su atención.",
    },
  },
  confirmInvite: {
    inviteUser:
      "Debes ingresar tu correo, recibirás un correo de confirmación para validar tu cuenta y poder ingresar al espacio.",
    inviteGuest: "Debes ingresar tu nombre antes de entrar al espacio.",
    expireOn: " Caduca el ",
  },
  gdpr: "Siguiendo las recomendaciones de",
  gdpr2:
    "te informamos que la información personal que cumplimentes será compartida con todos los usuarios del espacio. No rellenes lo que no desees compartir o escríbenos a",
  gdpr3: "para eliminar completamente tu cuenta.",
  loader: {
    loadingData: "¡Hola!",
    loadingSpaces: "¿Dónde están mis llaves?",
    loadingUser: "¡Las encontré!",
    connectingServices: "Comprobando que todo está bien",
    loadingUsers: "¿Quién vendrá hoy?",
    preparingSpace: "Encendiendo las luces",
    creatingSspace: "Preparando el café",
    checkingSpace: "Hoy va a ser un gran día",
    connectingRoom: "Uniéndote a la sala",
  },
  maintenance: {
    maintenance: "MANTENIMIENTO",
    maintenanceMessage:
      "Estamos realizando tareas de mantenimiento para actualizar nuestro sistema. El mantenimiento está previsto desde las {start} hasta {finish}",
    maintenanceMessageError:
      "Estamos realizando tareas de mantenimiento para actualizar nuestro sistema.",
  },
  webGLContextLost: {
    title: "Tu metaverso ha sido actualizado...",
    content:
      "Acabamos de actualizar tu metaverso. Por favor haz clic para recargarlo",
  },
  photonError: {
    title:
      "No hemos podido conectarnos a los servicios de nubi. Por favor, comprueba que tu conexión sea estable. En caso de estar bajo una red corporativa, es posible que este problema sea debido a un cortafuegos. En ese caso, ponte en contacto con el administrador de la red de tu organización.",
    buttonTitleBegin: "HAZ CLICK EN EL BOTÓN",
    buttonTitleEnd: "para conocer los requisitos de red de nubi",
    button: "Requisitos de red",
  },
  networkRequirementsTitle:
    "Aquí tienes una lista de los puertos que nubi puede usar:",

  googBye: "¿Te vas?",
  goodbyeText:
    "Si no has decidido irte, puede que seamos nosotros los que hemos detectado que quizás te hayas olvidado de nubi y te desconectamos para que otros avatares no te molesten. Si no es así, pulsa en el botón para volver.",
  placeholder: {
    email: "example@email.com",
    selectTypeSpace: "Selecciona el tipo de espacio",
    selectSpace: "Selecciona el espacio",
    dniOrNie: "DNI o NIE",
  },
  tutorial: {
    step1:
      "Antes de entrar en nubi te vamos a mostrar en tres simples pasos cómo desplazarte por el espacio",
    step2:
      '1- ¡Es hora de moverse!. Haz clic con el puntero de ratón  en el suelo y vuelve a hacer click en el emoji azul de "caminar"  para moverte',
    step3:
      "2- ¡Felicidades! Ahora vamos a una llamada. ¡Para activar la cámara y el micrófono, simplemente entra DENTRO de una sala y el micrófono y cámara  se configurarán  para iniciar una videollamada con las personas en la sala!",
    step4:
      "3- ¡Execlente! Último paso, cómo interactuar con otros usuarios. HAZ CLIC en ALEX y verás la lista de posibles acciones, como chatear, llamar, enviar un avión de papel, o ver la información de otro usuario, ¡HAZ CLIC EN CUALQUIERA DE ELLOS para terminar el tutorial!",
    stepComplete: "Felicidades!",
    tutorialComplete:
      "¡¡FANTÁSTICO!!, has completado el tutorial, nos vamos a nubi... Disfruta de la experiencia.",
  },
  goodMorning: {
    one: "Trabajar duro, una mente positiva y levantarse temprano son las claves para tener un gran día.",
  },
  invitationsActions: {
    deleteInvitation: "Eliminar invitaición",
    increaseInvitation: "Aumentar tiempo de expiración",
    descriptionDelete: "¿Realmente quieres eliminar esta invitación?",
    descriptionIncrease:
      "¿Realmente quieres aumentar el tiempo de expiración de esta invitacion?",
  },
  toolkit: {
    NUBII_TOOLS_MESSAGE_IMAGE_UPLOADED:
      "{name} ha subido una nueva fotografía.",
    NUBII_TOOLS_MESSAGE_NEW_POLL: "{name} ha añadido una nueva encuesta.",
    NUBII_TOOLS_MESSAGE_PPPS_REMINDER:
      "Recuerda que hoy tienes disponible el formulario PPPS.",
  },
  callMenu: {
    background: "Seleccionar fondo",
    record: "Grabar llamada",
    blur: "Desenfocar fondo",
    walkie: "Pulsar para hablar (tecla N)",
    noise: "Activar cancelación de ruido",
    config: "Configurar dispositivos",
    muteAll: "Silenciar a todos",
    videoOffAll: "Apagar video a todos",
    video: "Vídeo",
    mic: "Micrófono",
    otherOptions: "Otras opciones",
    resetCall: "Reiniciar la llamada",
  },
  recordGuide: {
    title: "Herramienta de grabación de nubi.",
    step1: "Haz clic en el botón rojo para iniciar la grabación.",
    step2:
      "Aparecerá una vista con la pantalla, ventana o pestaña que deseas grabar, selecciona la que desees (preferiblemente la pestaña de nubi).",
    step3: "Puedes pausar y reanudar la grabación cuando quieras.",
    step4:
      "Haz clic en stop para terminar la grabación y esta se descargará automaticamente en tu explorador.",
    step5: "Te recomendamos descargar",
    step5_2: "para ver los videos de nubi",
  },
  callIsRecord: "La llamada está siendo grabada",
  recordingCall: "{name} está grabando la llamada",
  recordCall: "Grabar llamada",
  knowledgeRecord: "Grabar conocimientos",
  knowledgeRecording: "Grabando conocimientos",
  knowledgeRecordTitle: "Graba tus conocimientos",
  autoVideo: {
    title: "Para finalizar, añade un título, una descripción y guarda, o rechaza si no estás contento con el resultado y no lo quieres guardar.",
    notSaved: "Si rechazas no se guardará el vídeo",
    decline: "Rechazar",
  },
  confignubii: {
    call: "Llamada",
    notification: "Notificaciones",
    sound: "Sonido",
    disableMic: "Iniciar siempre con micrófono apagado",
    disableCam: "Iniciar siempre con cámara apagada",
    volume: "Volumen de la llamada",
    silenceNotifications: "Silenciar notificaciones",
    silenceReactions: "Silenciar reacciones",
    scene: "Escenario",
    chat: "Chat",
    defaultChatOpen: "Mostrar siempre el chat abierto al entrar en llamada",
    disableSoundNotification: "Desenmudecer notificación",
    activeSendMailChat: "Haga clic para dejar de enviar el resumen del chat al final de la sesión.",
    disableSendMailChat: "Haga clic para enviar un resumen del chat al final de la sesión.",

  },
  admin: {
    sidebar: {
      analytics: "Estadísticas",
      goBack: "Volver atrás",
      dashboard: "Dashboard",
      spaces: "Espacios",
      multi_spaces: "Campus",
      users_list: "Usuarios",
      spaces_requests: "Solicitudes de espacio",
      new_space: "Crear nuevo espacio",
    },
    actions: {
      enabled: "Habilitar espacio",
      disabled: "Deshabilitar espacio",
      delete: "Eliminar espacio",
    },
    confirmDeleteSpace: {
      title: "Eliminar espacio",
      description: "¿Estás seguro de eliminar este espacio?",
    },
    confirmDisabledSpace: {
      title: "Deshabilitar espacio",
      description: "¿Estás seguro de deshabilitar este espacio?",
    },
    request_space: {
      spaceName: "Nombre del espacio",
      creatorEmail: "Correo del creador",
      spaceType: "Tipo de espacio",
      activationUrl: "Enlace de activacion",
      creationDate: "Fecha de creación",
    },
    dashboard: {
      welcome: "Bienvenido",
      welcomeDescription: "Aquí podrás gestionar todo nubi",
      usersLogin: "Usuarios activos",
      dau: "Usuarios activos diarios",
      wau: "Usuarios activos semanales",
      mau: "Usuarios activos mensuales",
    },
  },
  webinarModal: {
    title: "Webinar",
    enterWebinarSpan: "ATENCIÓN: ",
    enterWebinar1: "Bienvenido a la sala de WEBINAR.",
    enterWebinar2:
      'Este es un espacio para WEBINARS. Sólo los usuarios con permisos de "Speaker" podrán activar su cámara y audio, que estarán apagados por defecto. Dentro de la sala cualquier "Speaker" podrá invitar a participar a otros usuarios.',
    cancel: "Cancelar",
    accept: "Aceptar e ir a la reunión",
  },
  autoVideoEnterModal: {
    title: "Auto Video",
    enterAutoVideoSpan: "ATENCIÓN: ",
    enterAutoVideo1: "Bienvenido a la sala de Auto Video.",
    enterAutoVideo2:
      'Este es un espacio para Auto Video. Dentro de la sala podrá grabar conociminetos.',
    cancel: "Cancelar",
    accept: "Aceptar",
  },
  speedNetworkingModal: {
    title: "Speed Networking",
    connectWith: "Conectado con",
    nextConnection: "Próxima conexión en",
    preparingConnection: "Prepárate para tu próxima reunión",
    preparingConnectionDescription:
      "Esperando a tu compañero para iniciar la conexión",
    waitingMoreUsers: "Esperando a más usuarios para iniciar las conexiones",
    breakTime: "Tómate un descanso mientras preparamos tu próxima reunión",
    enterSpeedNetworking1: "Bienvenido a la sala de NETWORKING.",
    enterSpeedNetworking2:
      'Si pulsas sobre la opción de "Entrar" vas a tener video llamadas aleatorias con TODOS los usuarios de la sala. Al finalizar te conectaremos con otro avatar y así sucesivamente hasta que salgas o los hayas conocido a todos. Cuando quieras dejar de tener video llamadas simplemente sal de la sala de networking.',
    enterSpeedNetworkingSpan: "ATENCIÓN: ",
    enterSpeedNetworking3:
      "Si no quieres tener video llamadas con nadie y no deseas conocer nuevos usuarios del espacio ahora mismo, CANCELA ahora",
  },
  chatMenu: {
    general: "Chat general",
    pinnedMessages: "Mensajes anclados",
    openChats: "Chat abiertos",
  },
  userOnlineActions: {
    showProfile: "Ver perfil",
    call: "Llamar",
    chat: "Chat",
    disable: "Deshabilitar",
    enable: "Habilitar",
    goToSpace: "Ir al espacio",
  },
  messageActions: {
    pinMessage: "Anclar mensaje",
  },
  roomPin: {
    changePin: "Puedes asignar una CLAVE a la sala para convertirla en privada",
    enterPin: "Debes ingresar una CLAVE para poder entrar a la sala",
    pinNull: "si dejas la CLAVE en blanco quedará libre la sala",
    addPin: "Aplicar CLAVE de seguridad",
    removePin: "Liberar sala",
    errorPin: "La clave es incorrecto",
    doneChangePin: "CLAVE asignada satisfactoriamente",
    doneReleaseRoom: "Sala liberada satisfactoriamente",
    doneReleasePin: "Salas liberadas satisfactoriamente",
    releasePins: "Liberar todas las salas que tengan CLAVE",
    textfootchangePin: "Esta sala está permanentemente bloqueada",
    enterPinNotepad: "Debes ingresar la CLAVE de la sala",
  },
  spaceType: {
    OFFICE_TYPE: "Oficina",
    EVENT_TYPE: "Evento",
    EKAM_TYPE: "Espacio de meditación",
    LEARNING_TYPE: "Aprendizaje",
    MINISO_TYPE: "Espacio Ecommerce",
  },
  sceneType: {
    SMALL: "Pequeña",
    MEDIUM: "Mediana",
    LARGE: "Grande",
    AUTOMOTIVE: "Automotor",
    CONFERENCE_CENTER: "Conferencia pequeña",
    CONFERENCE_CENTER_LARGE: "Conferencia grande",
    CONFERENCE_COFFEE: "Cafetería",
    CONFERENCE_WEBINAR: "Conferencia con webinar",
    CONFERENCE_WEBINAR_SPEED_NETWORKING:
      "Conferencia con webinar y Speed Networking",
    FESTIVAL: "Concierto",
    LAKE_SINGLE_WEBINAR: "Lago con un webinar",
    TEMPLE: "Templo",
    MINISO: "Tienda virtual",
    LEARNING: "Aprendizaje",
    RECREATIVE: "Recreativa",
    AUDITORIUM: "Auditorio",
    LAKE_SINGLE_WEBINAR_LARGE_WITH_BOOTHS: "Gran lago un webinar",
    WEBINAR_SPEED_NETWORKING_PLATFORM:
      "Plataforma con webinar y Speed Networking",
    OFFICE_PLATFORM_NORMAL: "Plataforma oficina",
    AUDITORIUM_MINI: "Mini Auditorio",
    LEARNING_PLATFORM: "Plataforma Aprendizaje",
    GAMING_PLATFORM: "Plataforma de juegos",
    OFFICE_PLATFORM_NORMAL_TWO: "CTTI",
    AUDITORIUM_PLATFORM: "Plataforma Auditori",
    HAWKINGS_LARGE: "Hawkings grande",
    SHOWROOM_SMALL: "Showroom small",
    SHOWROOM_VERY_SMALL: "Showroom very small",
    SHOWROOM_NORMAL: "Showroom normal",
    SHOWROOM_LARGE: "Showroom large",
    SHOWROOM_BIG: "Showroom big",
    SHOWROOM_SUPER_BIG: "Showroom super big",
    SHOWROOM_NETWORKING: "Showroom networkings",
    SHOWROOM_SUPER_OFFICE: "Showroom super office",
    SHOWROOM_INVESTIGATION: "Showroom investigation",
    SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: "Showroom super big no wall",
    SHOWROOM_FOREST: "Showroom forest",
    SHOWROOM_OASIS: "Showroom oasis",
    SHOWROOM_TROPICAL: "Showroom tropical",
    SPACE_ISLANDS: "Space islands",
    SPACE_ISLANDS_XRF: "Space islands xrf",
    SPACE_ENEB: "Space eneb",
    CTTI_BURRA_CLUB: "La burra club",
    ENEB_SPACE_ISLANDS_BLUE : "Space eneb islands",
    HESPERIDES_ISLANDS: "Hesperides Islands",
  },
  languages: {
    en: "Inglés",
    ca: "Catalán",
    zk: "Chino mandarín",
    hi: "Hindi",
    es: "Español",
    fr: "Francés",
    ar: "Árabe",
    ru: "Ruso",
    pt: "Portugués",
    id: "Indonesio",
    de: "Alemán",
    ja: "Japonés",
    tr: "Turco",
    ko: "Coreano",
    it: "Italiano",
  },
  goodbyeUnsubscribe: "Te vamos a extrañar, gracias por formar parte de nubi.",
  goToNubiWeb: "Ir a la Web de nubi para más información",
  openLink: "Abrir enlace",
  posterRedirect:
    "Este cartel contiene una web de interés. Si aceptas, serás redirigido a una página externa de nubi.",
  chat: {
    confirmDelete: {
      title: "Limpiar chat",
      description:
        "¿Estás seguro de eliminar los mensajes del chat general?, no se podran ver los mensajes anteriores a esta acción",
    },
    userDelete: "Usuario borrado"
  },
  layoutTypes: {
    COLUMN: "Columna simple",
    GRID: "Cuadricula",
    COLUMN_LEFT: "Columna a la izquierda",
    // COLUMN_RIGHT = "COLUMN_RIGHT",
    COLUMN_TRANSPARENT_LEFT: "Columna a la izquierda",
    TOP_ROW: "Fila superior",
    TOP_SHARE: "Compartir grande",
  },
  callModal: {
    title: "te está llamando",
    restart: "¿Seguro que quieres reiniciar la llamada ?",
  },
  chatContent: {
    today: "Hoy",
    yesterday: "Ayer",
  },
  configurationSuperSpace: {
    titleButton: "Añadir IP para comprobar automáticamente si los usuarios están en la oficina o en casa",
    from: "Desde",
    to: "Hasta",
    range: "Rango",
    no: "No",
    yes: "Si",
    textCheckBoxFalse: "Marca para añadir IP por rango",
    textCheckBoxTrue: "Desmarca para añadir IP",
    ipNoValid: "IP no valida",
    alreadyExists: "Ya existe la IP",
    rangeAlreadyExusts: "Ya existe el rango de IPS",
    rangoMax: "La IP final no puede ser menor  que la inicial",
    confirmDelete: {
      title: "Eliminar IP",
      description: "¿Estás seguro de eliminar esta IP?",
    }
  },
  birthdayModal: {
    title: "¡Hoy es el cumpleaños de {name}!",
    congratulateBirthday: "¡Feliz Cumpleaños!",
    birthdayMessage1: "¡Feliz cumpleaños! ¡Disfruta mucho de tu día!",
    birthdayMessage2: "Muchas felicidades, a disfrutar, ¡lo mereces!",
    birthdayMessage3: "¡Que cumplas muchos más!",
    birthdayMessage4: "¡Felicidades, un año más joven!",
    birthdayMessage5: "¡Un año más dando guerra!",
  },
  favouriteSpace: {
    campus: "Campus",
    favouriteSpace: "Espacios favoritos",
    modalFavouriteSelector: {
      title: "Espacios favoritos",
      noFavourite: "No tienes espacios favoritos",
    }
  },
  callContentComponent: {
    waiting: "Conectado. Esperando a los presentadores...",
  },
  eventCalendarComponent: {
    empty: "No hay ningún evento programado",
  },
  codeErrorApi: {
    ERROR_ROOM_INVALID_PIN: "PIN inválido",
  },
  loginMicrosoft: {
    loading: "Identificando..."
  },
  floatingMenu: {
    poll: "Encuesta",
    notepad: "Bloc de notas",
  },
  poll: {
    vote: "Votar",
    endPoll: "Eliminar encuesta",
    pollEnded: "Encuesta finalizada",
    currentPoll: "Encuesta actual",
    createNewPoll: "Crear una nueva encuesta",
    question: "Pregunta",
    responses: "Respuestas (Mínimo 2)",
    duration: "Duración",
    pollSuccessNotifications: "Encuesta creada exitosamente",
    confirmCancelPoll: "¿Estás seguro de eliminar la encuesta?",
  },
  robot: {
    helpYou: "Hola soy {name}. ¿En que puedo ayudarte?",
    questionHere: "Escribe aquí tu pregunta",
    sendQuestion: "Enviar pregunta",
    waitingResponse: "Esperando respuesta",
    aiNotAvailable: "En estos momentos la inteligencia artificial no está disponible",
  },
  register: {
    activeUser: "Bienvenido a Hawkings, revisa tu correo.",
    registeredUserError: "El usuario ya está registrado ",
    activationAlreadyDone: "La activación ya se ha realizado",
    country: "País",
    registerHere: "¿No tienes una cuenta? Regístrar aquí",
    register: "Registrarse",
    termsAndConditions1: "Al continuar, reconoces y aceptas nuestro",
    termsAndConditions2: "Términos y condiciones",
    termsAndConditions3: "y",
    termsAndConditions4: "Política de privacidad",
    back: "< Volver al inicio",
    name: "Nombre",
    yourName: "Tu nombre",
    lastName: "Apellido",
    yourLastName: "Tu apellido",
    emailAddress: "Dirección de correo electrónico",
    emailAddressExample: "tu@correo.com",
    select: "Seleccionar",
    password: "Contraseña",
    yourPassword: "Tu contraseña",
    confirmYourPassword: "Confirma tu contraseña",
    passwordConfirmation: "Confirmación de la contraseña",
  },
  education: {
    selectRole: "Selecciona el rol",
    teacher: "Profesor",
    student: "Alumno",
    staff: 'Personal',
    teacherTooltip: 'Acceso limitado a espacios y salas específicas. No puede moderar o acceder a herramientas de profesores.',
    studentTooltip: 'Acceso a herramientas educativas, puede moderar salas y tiene la capacidad de añadir contenido educativo.',
    staffTooltip: 'Acceso limitado a herramientas administrativas, puede moderar y tiene permisos para añadir o eliminar usuarios en un espacio específico.',
    superAdminTooltip: 'Control total sobre todos los aspectos del campus, incluida la administración de roles y permisos.',
  },
  hawkings: {
    questionHere: "Tu mensaje",
    sendQuestion: "Enviar mensaje",
    newConversation: "+ Nueva conversación",
    examGenerator: "Generador de exámenes",
    examGeneratorDescription: "Esta herramienta te ayuda en la creación de exámenes, adaptándolos al nivel y necesidades de cada grupo de estudiantes. Por ejemplo, ¿cómo crearías un examen para evaluar el conocimiento básico de matemáticas en niños de primaria? ¿y cómo diseñarías una prueba para un curso avanzado de física? La app facilita este proceso, garantizando evaluaciones justas y equilibradas.",
    educationLaw: "Ley educativa",
    selectEducationalLaw: "Selecciona una ley educativa",
    subjects: "Asignaturas",
    selectSubject: "Selecciona una asignatura",
    educationalProgram: "Programa educativo",
    questions: "Preguntas",
    numberQuestions: "Número de preguntas",
    additionalComments: "Comentarios adicionales",
    anyAdditionalInstructions: "Cualquier instrucción adicional para generar el examen",
    language: "Idioma",
    selectLanguage: "Seleccionar un idioma",
    generateButton: "Generar",
    untitledDocument: "Documento sin título...",
    deleteButton: "Eliminar",
    download: "Descargar",
    copyToClipboard: "Copiar al portapapeles",
    examCopiedClipboard: "Examen copiado en el portapapeles",
    course: "Curso",
    selectCourse: 'Selecciona un curso',
    tools: "Herramientas",
    chatBot: "Chatbot",
    clearInputs: "Limpiar Campos",
    example: "Ejemplo",
    messageCopiedClipboard: "Copiado al portapapeles",
    clickSelectAssistant: "Haz clic para seleccionar el asistente",
  },
  CTTI: {
    questionGameModalText: "¿Quieres jugar?",
    spotyfyModal: {
      title: "¿Quieres escuchar la lista de reproducción seleccionada esta semana?",
      openWeb: "Abrir desde la web",
      openApp: "Abrir desde la aplicación",
      addList: "Añade tu lista de reproducción al perfil",
      addTitle: "Cómo copiar la url de la lista que deseas compartir de spotify, desde la web",
      addTitle1: "aquí",
      addTitle2: "y desde la aplicación",
      tutorial: "Haz clic en los tres puntos - Compartir - Copiar enlace de la lista, luego pégalo en el contenedor y añadir.",
      add: "Añadir",
      sidebarListToMusic: "Escuchar música",
      listOf: "La lista selecionada es de",
      close: "Cerrar",
    },
    calendar: {
      calendarTitle: "Calendario",
    },
    reservationRoom: {
      reserveVirtualRooms: "Reserva sala virtual",
      toReserve: "Reservar",
      created: "Creado por",
      room: "Sala",
      of: "Desde las",
      to: "Hasta las",
      roomNoName: "Sala Sin nombre",
      title: "Título",
      shortDescription: "Descripción corta",
      selectTheRoom: "Selecciona la sala",
      selectTheReservationTime: "Selecciona la hora de reserva",
      invalidRange: "Rango no valido",
      reservedHours: "Horas reservadas",
      selectTheUsersYouWantToInvite: "Selecciona los usuarios que quieres invitar",
      selectedUsersToInvite: "Usuarios seleccionados para invitar",
      inviteExternalUsersWithYourEmail: "Invita a usuarios externos con su correo",
      editReservation: "Editar reserva",
      accessPin: "PIN de acceso",
      reserveVirtualRoom: "Sala virtual",
      reservePhysicalRoom: "Sala física",
      description: "Descripción",
      googleMeet : "Google Meet",
      signOut: "Cerrar sesíon",
      signInGoogle: "Iniciar sesión con Google",
      signInHotmail: "Iniciar sesión con Hotmail",
    },
    reservationsPhysicalRoom: {
      reserveVirtualRooms: "Reserva sala física",
      selectPlant: "Selecciona la planta",
      selectRoom: "Selecciona la sala",
    },
  },
  gameKiller: {
    answers1: "En un giro dramático de eventos, los jugadores han localizado y desafiado al zombi {data}, asegurando la seguridad de todos. ¡Felicidades por un juego bien jugado!",
    answers2: "El silencio cubre el escenario... El zombi {data} ha triunfado en la sombra, reclamando la victoria sobre todos. Mejor suerte la próxima vez",
    answers3: "Tras un intenso debate, la decisión es unánime: nadie será expulsado esta ronda. La tensión aumenta mientras el juego continúa.",
    answers4: "Tras la votación, {data} fue expulsado, sellando su destino entre lamentos. La verdad se revela amarga; era inocente, y su partida solo deja más preguntas sin responder.",
    report: "Reportar",
    title: "Juego del zombi",
    eliminated: "Infectados",
    minimize: "Minimizar",
    information: "Información",
    vote: "Votar",
    titleReport: "Seleccionar a un usuario y escribe un breve texto sobre por qué crees que ese jugador debería ser eliminado",
    selectUser: "Seleccionar usuario",
    textRepor: "Breve texto explicando por qué hay que eliminarlo",
    sendReport: "Enviar reporte",
    titleVote: "Votación para eliminar a {data1}, {data2} reportó con el siguiente mensaje: {data3}",
    yes: "Si",
    no: "No",
    resultWaiting: "Esperando resultado",
    sendVote: "Enviar voto",
    titleActive: "El juego del zombi está activo",
    tutorial1Title: "Descripción general",
    tutorial1: "Este es un juego donde los participantes se ven envueltos en un misterioso escenario en el cual uno de ellos es designado como zombi. La meta del juego es descubrir la identidad del zombi antes de que este logre infectar a todos los demás participantes. A lo largo de la partida, los jugadores tendrán que utilizar su astucia eintuición para sobrevivir y resolver el misterio.",
    tutorial2Title: "Cómo se juega siendo el zombi",
    tutorial2: "Si resultas ser el zombi, tendrás la capacidad de infectar  a tus compañeros. Esto se logra haciendo clic en un usuario específico. Si al hacer clic te aparece un icono de jeringuilla, significa que tienes la posibilidad de infectar a ese jugador. Debes proceder con cautela: al hacer clic en el icono de la jeringuilla, te acercarás sigilosamente a tu objetivo, y una vez estés lo suficientemente cerca, lo infectaras. Los jugadores infectados  serán identificables por un icono distinto sobre su cabeza. Es importante recordar que, si has sido infectado, quedas fuera de juego, incapaz de reportar o comunicar a los demás jugadores quién fue tu el que te infectó.",
    tutorial3Title: "Cómo reportar al zombi",
    tutorial3: "Si sospechas quién puede ser el zombi, o si estás convencido de su identidad, tienes la opción de señalarlo mediante un botón específico para realizar denuncias. Después de usar este botón, se activará un periodo de enfriamiento que te impedirá hacer otra denuncia inmediatamente. Debes elegir al jugador que crees que es el zombi y proporcionar una explicación concisa de tus sospechas. Esto iniciará una votación con una duración determinada, permitiendo que los otros jugadores voten a favor o en contra de la acusación. Si la votación concluye afirmativamente y el acusado resulta ser el zombi, todos los jugadores ganan. No obstante, si la votación acaba con la eliminación de un inocente, y tú fuiste quien hizo la denuncia, no podrás denunciar a otro jugador durante las siguientes 48 horas, y el juego proseguirá sin el jugador infectado. Si la votación es negativa, el juego continúa normalmente sin afectar al acusado. El zombi se declara ganador si logra infectar al resto de los jugadores sin ser descubierto.",
    tutorial4Title: "Cómo se juega si no eres el zombi",
    tutorial4: "Si no eres el zombi, tu objetivo será sobrevivir y colaborar con los demás jugadores para identificar al culpable. Mantente atento a las conductas sospechosas, utiliza el botón de reporte con prudencia, y participa activamente en las discusiones y votaciones. Recuerda, tu instinto y habilidad para deducir serán clave para desenmascarar al zombi antes de que sea demasiado tarde.",
    zombie: "Zombi",
    Innocent: "Inocente",
    blockDelete: "No puedes infectar mientras la votación esté activa",
    blockKillerDelete: "Debes esperar {data} antes de poder continuar con la eliminación",
    howToPlay: "Cómo se juega",
    infected: "Infectado",
    lastDead: "Último infectado {data}",
    gameDiary: "Diario de juego",
  },
  usersGround: {
    groups: "Grupos",
    createGroups: "Crear grupo",
    editGroup: "Editar grupo",
    editUsers: "Editar usuarios",
  },
  level: {
    NATIVE: "Nativo",
    LOW: "Bajo",
    MEDIUM: "Medio",
    HIGH: "Alto",
  },
  gender: {
    ML: "Masculino",
    FM: "Femenino",
    OTHER: "Otros",
    NONE: "Dejar en blanco"
  },
  plans: {
    premium: "Premium",
    title: "Descubre el Plan Premium: ¡Lleva tu experiencia al siguiente nivel!",
    description: "¿Estás listo para disfrutar de lo mejor que nuestra web tiene para ofrecer? Con el Plan Premium, desbloquearás una serie de beneficios exclusivos diseñados para brindarte más valor, comodidad y ventajas que nunca.",
    seeBenefits: "Ver beneficios",
    hirePlan: "Contratar plan",
    maxSimultaneusConnections: "Se ha alcanzado el máximo de conexiones simultáneas. Por favor, espere a que haya un espacio disponible.",
    features: {
      "UserLink": "Enlace de Usuario",
      "UserLinkDescription": "Genera un enlace de invitación para cualquier persona que quieras que sea un usuario recurrente de tu espacio.",
      "GuestLink": "Enlace de Invitado",
      "GuestLinkDescription": "Genera un enlace de invitación para cualquier persona que quieras que sea un usuario puntual y solo invitado a tu espacio.",
      "FavoriteSpace": "Espacio Favorito",
      "FavoriteSpaceDescription": "Marca tus espacios favoritos.",
      "SearchFilters": "Filtros de Búsqueda",
      "SearchFiltersDescription": "Filtra por conocimiento, expertos en materias y proyectos dentro de tu grupo de usuarios.",
      "UserListRolls": "Rol de la Lista de Usuarios",
      "UserListRollsDescription": "Muestra el puesto de trabajo de cada usuario.",
      "UserProfile": "Perfil de Usuario",
      "UserProfileDescription": "Perfil completo con toda la información de cada usuario.",
      "GeneralChat": "Chat General",
      "GeneralChatDescription": "Chat general para todos los usuarios que están dentro del espacio.",
      "RoomsChat": "Chat de Salas",
      "RoomsChatDescription": "Chat exclusivo para los usuarios dentro de cada sala.",
      "PrivateChat": "Chat Privado",
      "PrivateChatDescription": "Chat privado con cualquier usuario del espacio.",
      "Powerups": "Powerups",
      "PowerupsDescription": "Selección de herramientas como registro de tareas, reportes semanales, formularios de vacaciones, álbumes de fotos, etc.",
      "Reactions": "Reacciones con y sin Sonido",
      "ReactionsDescription": "Reacciones en los chats, con o sin sonido (aplausos, tambores, etc.).",
      "SpotifyList": "Listas de Spotify",
      "SpotifyListDescription": "Comparte listas de Spotify con tus compañeros.",
      "VirtualRoomBooking": "Reservar Sala Virtual",
      "VirtualRoomBookingDescription": "Reserva salas virtuales en Nubi.",
      "PhysicalRoomBooking": "Reservar Sala Física",
      "PhysicalRoomBookingDescription": "Reserva las salas de tu oficina física desde Nubi.",
      "CampusSpaces": "Campus con Diferentes Espacios",
      "CampusSpacesDescription": "Crea un campus con múltiples espacios dentro.",
      "Support": "Soporte",
      "SupportDescription": "Escribe directamente al soporte de Nubi para obtener ayuda.",
      "DefaultPlace": "Marca tu Lugar por Defecto",
      "DefaultPlaceDescription": "Configura tu lugar predeterminado donde aparecerás cada vez que te conectes.",
      "ChangeStatus": "Cambia tu Estado",
      "ChangeStatusDescription": "Actualiza tu estado para que otros usuarios lo vean.",
      "WorkFromHome": "Indica si Trabajas desde Casa o la Oficina",
      "WorkFromHomeDescription": "Especifica desde dónde estás trabajando: casa u oficina.",
      "CreateResume": "Crea tu CV y Vincula tus Redes Sociales",
      "CreateResumeDescription": "Crea tu currículum en tu perfil e incluye tus redes sociales.",
      "CustomAvatars": "Avatares Personalizados",
      "CustomAvatarsDescription": "Elige y cambia tu avatar cuando quieras.",
      "CustomSpaces": "Espacios Completamente Personalizables",
      "CustomSpacesDescription": "Diseña y personaliza los espacios según tus necesidades.",
      "ChoosePet": "Elige tu Mascota",
      "ChoosePetDescription": "Selecciona una mascota para que acompañe a tu avatar.",
      "Notepad": "Bloc de Notas",
      "NotepadDescription": "Toma notas dentro de las salas.",
      "WeblinkPanels": "Paneles con Enlaces Web",
      "WeblinkPanelsDescription": "Incluye enlaces a sitios web o videos en paneles dentro de los espacios.",
      "Webinars": "Webinars",
      "WebinarsDescription": "Salas donde los usuarios participan como oyentes y solo ven y escuchan al ponente.",
      "MeetingRooms": "Salas de Reunión",
      "MeetingRoomsDescription": "Llamadas donde los usuarios pueden activar cámara y micrófono.",
      "NetworkingRooms": "Salas de Networking",
      "NetworkingRoomsDescription": "Conecta usuarios al azar en llamadas de 2-3 minutos.",
      "ShareScreens": "Compartir Varias Pantallas",
      "ShareScreensDescription": "Muestra más de una pantalla a la vez.",
      "RaiseHand": "Levanta la Mano para Hablar",
      "RaiseHandDescription": "Notifica a los demás usuarios que deseas hablar o preguntar.",
      "BlurBackground": "Difumina tu Fondo",
      "BlurBackgroundDescription": "Aplica un efecto de desenfoque en tu fondo durante las videollamadas.",
      "CustomBackgrounds": "Fondos Personalizados",
      "CustomBackgroundsDescription": "Configura un fondo personalizado para tus videollamadas.",
      "NoiseCancellation": "Cancelación de Ruido",
      "NoiseCancellationDescription": "Elimina el ruido de fondo en llamadas.",
      "TurnOffVideos": "Apaga los Videos de Todos",
      "TurnOffVideosDescription": "Desactiva el video de todos los usuarios en la llamada.",
      "MuteEveryone": "Silencia a Todos",
      "MuteEveryoneDescription": "Silencia los micrófonos de todos los usuarios en la llamada.",
      "BlockPrivateRooms": "Bloqueo de Salas Privadas",
      "BlockPrivateRoomsDescription": "Protege salas con un código de acceso.",
      "ShareVideo": "Comparte un Video",
      "ShareVideoDescription": "Reproduce un video dentro de una sala.",
      "CastVote": "Realiza una Encuesta",
      "CastVoteDescription": "Crea encuestas para los usuarios conectados.",
      "EventsAgenda": "Agenda de Eventos",
      "EventsAgendaDescription": "Organiza la dinámica del evento con una agenda.",
      "MuteNotifications": "Silencia Notificaciones",
      "MuteNotificationsDescription": "Desactiva las notificaciones entrantes.",
      "Recording": "Grabación de Reuniones",
      "RecordingDescription": "Graba las llamadas y consérvalas.",
      "ConcentrationMode": "Modo Concentración",
      "ConcentrationModeDescription": "Oculta el fondo de Nubi para concentrarte en presentaciones o llamadas.",
      "ChangeCameras": "Cambia el Diseño de las Cámaras",
      "ChangeCamerasDescription": "Modifica la disposición de las cámaras según tu preferencia.",
      "RobotsRooms": "Salas con Robots e IA",
      "RobotsRoomsDescription": "Incluye robots de IA en movimiento y bots dentro de las salas.",
      "PinMessages": "Pinea",
      "PinMessagesDescription": "Fija mensajes importantes o elimínalos.",
      "Games": "Juegos",
      "GamesDescription": "Funciones de entretenimiento integradas.",
      "GoogleCalendarIntegration": "Integración con Google Calendar",
      "GoogleCalendarIntegrationDescription": "Sincroniza con tu Google Calendar.",
      "OutlookIntegration": "Integración con Outlook",
      "OutlookIntegrationDescription": "Sincroniza con tu Outlook.",
      "TeamsIntegration": "Integración con Microsoft Teams",
      "TeamsIntegrationDescription": "Conecta con Microsoft Teams.",
      "DomainName": "Dominio Propio",
      "DomainNameDescription": "Utiliza un dominio personalizado con tu nombre corporativo.",
      "BookMeetings": "Reserva Reuniones",
      "BookMeetingsDescription": "Agendas reuniones directamente desde la plataforma.",
      "MobileApp": "Aplicación Móvil",
      "MobileAppDescription": "Disponible para dispositivos móviles.",
      "BrandWithLogos": "Branding con Logos",
      "BrandWithLogosDescription": "Personaliza tu espacio con los logos de tu empresa.",
      "BrandWithNames": "Branding con Nombres de Salas",
      "BrandWithNamesDescription": "Asigna nombres personalizados a cada sala del espacio.",
      "WalkToAvatar": "Camina Hacia Otro Avatar",
      "WalkToAvatarDescription": "Dirige a tu avatar hacia otro usuario en el espacio.",
      "SendPaperPlane": "Envía un Avión de Papel",
      "SendPaperPlaneDescription": "Llama la atención de otro usuario enviándole un avión de papel.",
      "KickBanUser": "Expulsa o Banea Usuarios",
      "KickBanUserDescription": "Elimina o restringe usuarios del espacio.",
      "SendAnnouncements": "Anuncios Generales",
      "SendAnnouncementsDescription": "Envía mensajes para todos los usuarios con o sin sonido.",
      "Metrics": "Métricas",
      "MetricsDescription": "Accede a información estadística de los usuarios del espacio.",
      "Multiwebinar": "Multiwebinar",
      "MultiwebinarDescription": "Activa webinars simultáneos en múltiples espacios.",
      "CreateUserGroups": "Crea Grupos de Usuarios",
      "CreateUserGroupsDescription": "Organiza a los usuarios en grupos.",
      "EventLogs": "Registros de Eventos",
      "EventLogsDescription": "Consulta registros de conexión y desconexión.",
      "ScheduledAnnouncements": "Anuncios Programados",
      "ScheduledAnnouncementsDescription": "Deja mensajes o avisos programados.",
      "BusinessCards": "Tarjetas de Presentación",
      "BusinessCardsDescription": "Genera tarjetas descargables con información del perfil de los usuarios.",
      "SelfRecording": "Autograbación de Videos",
      "SelfRecordingDescription": "Crea videos grabados para otros usuarios.",
      "SSO": "Inicio de Sesión Único (SSO)",
      "SSODescription": "Autenticación centralizada para acceder al espacio.",
      "Zumbar": "Zumbar",
      "ZumbarDescription": "Notifica de manera privada a un usuario que está cometiendo un error, sin que los demás se den cuenta.",
      "MaximumConnections": "Máximo de conexiones",
      "MaximumConnectionsDescription": "Hasta un máximo de 200 conexiones simultáneas.",
      "MaximumSpaces": "Máximo de espacios",
      "MaximumSpacesDescription": "Hasta un máximo de 20 espacios.",
    }
  },
  nationality: {
    "AF": "Afgana",
    "AX": "Ålandesa",
    "AL": "Albanesa",
    "DZ": "Argelina",
    "AS": "Samoana Americana",
    "AD": "Andorrana",
    "AO": "Angoleña",
    "AI": "Anguilense",
    "AQ": "Antártica",
    "AG": "Antiguana y Barbudeña",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Arubeña",
    "AU": "Australiana",
    "AT": "Austriaca",
    "AZ": "Azerbaiyana",
    "BS": "Bahameña",
    "BH": "Bareiní",
    "BD": "Bangladesí",
    "BB": "Barbadense",
    "BY": "Bielorrusa",
    "BE": "Belga",
    "BZ": "Beliceña",
    "BJ": "Beninesa",
    "BM": "Bermudeña",
    "BT": "Butanesa",
    "BO": "Boliviana",
    "BA": "Bosnia y Herzegovina",
    "BW": "Botsuana",
    "BV": "de la Isla Bouvet",
    "BR": "Brasileña",
    "IO": "del Territorio Británico del Océano Índico",
    "BN": "Bruneana",
    "BG": "Búlgara",
    "BF": "Burkinesa",
    "BI": "Burundesa",
    "KH": "Camboyana",
    "CM": "Camerunesa",
    "CA": "Canadiense",
    "CV": "Caboverdiana",
    "KY": "Caimanense",
    "CF": "Centroafricana",
    "TD": "Chadiana",
    "CL": "Chilena",
    "CN": "China",
    "CX": "de la Isla de Navidad",
    "CC": "Cocosiana (Keeling)",
    "CO": "Colombiana",
    "KM": "Comorense",
    "CG": "Congoleña",
    "CD": "Congoleña Democrática",
    "CK": "Cookiana",
    "CR": "Costarricense",
    "CI": "Marfileña",
    "HR": "Croata",
    "CU": "Cubana",
    "CY": "Chipriota",
    "CZ": "Checa",
    "DK": "Danesa",
    "DJ": "Yibutiana",
    "DM": "Dominiquesa",
    "DO": "Dominicana",
    "EC": "Ecuatoriana",
    "EG": "Egipcia",
    "SV": "Salvadoreña",
    "GQ": "Ecuatoguineana",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Etíope",
    "FK": "Malvinense",
    "FO": "Feroesa",
    "FJ": "Fiyiana",
    "FI": "Finlandesa",
    "FR": "Francesa",
    "GF": "Guayanesa Francesa",
    "PF": "Polinesia Francesa",
    "TF": "de los Territorios Australes Franceses",
    "GA": "Gabonesa",
    "GM": "Gambiana",
    "GE": "Georgiana",
    "DE": "Alemana",
    "GH": "Ghanesa",
    "GI": "Gibraltareña",
    "GR": "Griega",
    "GL": "Groenlandesa",
    "GD": "Granadina",
    "GP": "Guadalupeña",
    "GU": "Guameña",
    "GT": "Guatemalteca",
    "GG": "Guernesey",
    "GN": "Guineana",
    "GW": "Guineana Bissau",
    "GY": "Guyanesa",
    "HT": "Haitiana",
    "HM": "de la Isla Heard y las Islas McDonald",
    "VA": "Vaticana",
    "HN": "Hondureña",
    "HK": "Hongkonesa",
    "HU": "Húngara",
    "IS": "Islandesa",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iraní",
    "IQ": "Iraquí",
    "IE": "Irlandesa",
    "IM": "Manesa",
    "IL": "Israelí",
    "IT": "Italiana",
    "JM": "Jamaicana",
    "JP": "Japonesa",
    "JE": "Jersiana",
    "JO": "Jordana",
    "KZ": "Kazaja",
    "KE": "Keniana",
    "KI": "Kiribatiana",
    "KR": "Coreana (Sur)",
    "KW": "Kuwaití",
    "KG": "Kirguisa",
    "LA": "Laosiana",
    "LV": "Letona",
    "LB": "Libanesa",
    "LS": "Lesothense",
    "LR": "Liberiana",
    "LY": "Libia",
    "LI": "Liechtensteinese",
    "LT": "Lituana",
    "LU": "Luxemburguesa",
    "MO": "Macaense",
    "MK": "Macedonia",
    "MG": "Malagasy",
    "MW": "Malauí",
    "MY": "Malasia",
    "MV": "Maldiva",
    "ML": "Maliense",
    "MT": "Maltesa",
    "MH": "Marshalesa",
    "MQ": "Martiniquesa",
    "MR": "Mauritana",
    "MU": "Mauricia",
    "YT": "Mayotesa",
    "MX": "Mexicana",
    "FM": "Micronesia",
    "MD": "Moldava",
    "MC": "Monegasca",
    "MN": "Mongola",
    "ME": "Montenegrina",
    "MS": "Montserratense",
    "MA": "Marroquí",
    "MZ": "Mozambiqueña",
    "MM": "Myanmena",
    "NA": "Namibia",
    "NR": "Nauruana",
    "NP": "Nepalí",
    "NL": "Neerlandesa",
    "AN": "de las Antillas Neerlandesas",
    "NC": "Neocaledonia",
    "NZ": "Neozelandesa",
    "NI": "Nicaragüense",
    "NE": "Nigerina",
    "NG": "Nigeriana",
    "NU": "Niueana",
    "NF": "Norfolkesa",
    "MP": "Norte Mariana",
    "NO": "Noruega",
    "OM": "Omaní",
    "PK": "Pakistaní",
    "PW": "Palaosiana",
    "PS": "Palestina",
    "PA": "Panameña",
    "PG": "Papú",
    "PY": "Paraguaya",
    "PE": "Peruana",
    "PH": "Filipina",
    "PN": "Pitcairn",
    "PL": "Polaca",
    "PT": "Portuguesa",
    "PR": "Puertorriqueña",
    "QA": "Catarí",
    "RE": "Reunionense",
    "RO": "Rumana",
    "RU": "Rusa",
    "RW": "Ruandesa",
    "BL": "San Bartolomé",
    "SH": "Santa Elena",
    "KN": "Kittsiana y Nevisiana",
    "LC": "Santa Luciense",
    "MF": "San Martinense (parte francesa)",
    "PM": "San Pedrino y Miquelonés",
    "VC": "San Vicentesa y Granadina",
    "WS": "Samoana",
    "SM": "Sanmarinense",
    "ST": "Santomense",
    "SA": "Saudí",
    "SN": "Senegalesa",
    "RS": "Serbia",
    "SC": "Seychelense",
    "SL": "Sierraleonesa",
    "SG": "Singapurense",
    "SK": "Eslovaca",
    "SI": "Eslovena",
    "SB": "Salomonense",
    "SO": "Somalí",
    "ZA": "Sudafricana",
    "GS": "de Georgia del Sur y Sandwich del Sur",
    "ES": "Española",
    "LK": "Srilanquesa",
    "SD": "Sudanesa",
    "SR": "Surinamesa",
    "SJ": "Svalbard y Jan Mayen",
    "SZ": "Suazilandesa",
    "SE": "Sueca",
    "CH": "Suiza",
    "SY": "Siria",
    "TW": "Taiwanesa",
    "TJ": "Tayika",
    "TZ": "Tanzana",
    "TH": "Tailandesa",
    "TL": "Timorense",
    "TG": "Togolesa",
    "TK": "Tokelauense",
    "TO": "Tongana",
    "TT": "Trinitense y Tobagüense",
    "TN": "Tunecina",
    "TR": "Turca",
    "TM": "Turcomana",
    "TC": "Turcas y Caicosense",
    "TV": "Tuvaluana",
    "UG": "Ugandesa",
    "UA": "Ucraniana",
    "AE": "Emiratí",
    "GB": "Británica",
    "US": "Estadounidense",
    "UM": "de Islas Menores Alejadas de los Estados Unidos",
    "UY": "Uruguaya",
    "UZ": "Uzbeca",
    "VU": "Vanuatuense",
    "VE": "Venezolana",
    "VN": "Vietnamita",
    "VG": "Virgen Británica",
    "VI": "Virgen de los Estados Unidos",
    "WF": "Wallis y Futuna",
    "EH": "Saharaui",
    "YE": "Yemení",
    "ZM": "Zambiana",
    "ZW": "Zimbabuense"
  }
};
export default es;
